<ng-container *ngFor="let filter of filters; let i = index">
  <ap-filter-item (disable)="onDisable(i)" (edit)="onEdit(i)" (remove)="onRemove(i)" [filter]="filter"></ap-filter-item>
</ng-container>